import { cn } from '@packages/shared/src/utils/cn/cn';

const tipTopBottom =
  'before:border-l-color-transparent before:border-r-color-transparent before:scale-y-150 before:border-r-8 before:border-l-8';
const tipAside =
  'before:border-t-color-transparent before:border-b-color-transparent before:scale-x-150 before:border-t-8 before:border-b-8';
const tipTop = 'before:border-b-color-text-light before:-top-1 before:border-b-8';
const tipBottom = 'before:border-t-color-text-light before:-bottom-1 before:border-t-8';
const tipLeftAside = 'before:border-r-color-text-light before:-left-1 before:border-r-8';
const tipRightAside = 'before:border-l-color-text-light before:-right-1 before:border-l-8';
const tipRight = 'before:right-1';
const tipLeft = 'before:left-1';

const toolTipBottomRight = cn('mt-4', tipTop, tipLeft, tipTopBottom);
const toolTipBottomLeft = cn('mt-4', tipTop, tipRight, tipTopBottom);
const toolTipTopRight = cn('bottom-0 mb-4.5', tipBottom, tipLeft, tipTopBottom);
const toolTipTopLeft = cn('bottom-0 mb-4.5', tipBottom, tipRight, tipTopBottom);
const toolTipRight = cn('left-4 -mt-1', tipLeftAside, tipAside);
const toolTipLeft = cn('right-4 -mt-1', tipRightAside, tipAside);

export const toolTipStyles = {
  toolTipBottomRight,
  toolTipBottomLeft,
  toolTipTopRight,
  toolTipTopLeft,
  toolTipRight,
  toolTipLeft,
};
